export default "__VITE_ASSET__CvioH2Eq__"